<template>
    <v-layout justify-center class="pagemargin page">
      <notifications group="password-changed" position="top center" />
      <v-flex xs12 sm6 md3>
        <v-card-title primary-title>
          <notifications group="not-matching-passwords" position="top center" />

          <h4 class="headline mb-0">Please enter your new password</h4>
        </v-card-title>
        <br />
        <v-form>
          <v-text-field
            :append-icon="show ? 'visibility' : 'visibility_off'"
            :rules="[rules.required, rules.min]"
            :type="show ? 'text' : 'password'"
            @click:append="show = !show"
            hint="At least 8 characters"
            v-model.trim="Form.password"
            label="Password"
            solo
            data-vv-name="password"
            v-validate="'required|max:12'"
            :error-messages="errors.collect('password')"
            required
          ></v-text-field>

          <v-text-field
            :append-icon="show ? 'visibility' : 'visibility_off'"
            :rules="[rules.required, rules.min]"
            :type="show ? 'text' : 'password'"
            @click:append="show = !show"
            hint="At least 8 characters"
            v-model.trim="Form.confirmPassword"
            label="Confirm Password"
            solo
            data-vv-name="confirmPassword"
            v-validate="'required|max:12'"
            :error-messages="errors.collect('confirmPassword')"
            required
          ></v-text-field>

          <p class="mt-4">
            <center>
              <div v-if="Form.passwordChanged == false">
                <v-btn
                  color="primary"
                  :disabled="errors.any()"
                  @click="resetPassword"
                  round
                  block
                  class="caption font-weight-light"
                >Reset Password</v-btn>
              </div>
            </center>
          </p>
          <div v-if="Form.passwordChanged == true">
            <v-btn
              color="primary"
              :disabled="errors.any()"
              @click="login"
              round
              block
              class="caption font-weight-light"
            >Login</v-btn>
          </div>
          <!-- Form: {{ Form }}
          Link: {{this.FirebaseFunctionsURL +
                    "resetPassword?userEmail=" +
                    this.Form.email +
                    "&passwordResetCode=" +
                    this.Form.PWC +
                    "&newPassword=" +
          this.Form.confirmPassword}}-->
        </v-form>
      </v-flex>
    </v-layout>
</template>

<script>
import { mapState } from "vuex";
import Vue from "vue";
import Axios from "axios";

export default {
  $_veeValidate: { validator: "new" },
  data() {
    return {
      Form: {
        password: "",
        confirmPassword: "",
        email: "",
        PWC: "",
        passwordChanged: false
      },
      show: false,
      rules: {
          required: value => !!value || 'Required.',
          min: v => v.length >= 8 || 'Min 8 characters'
        }
    };
  },
  computed: {
    ...mapState({
      FirebaseFunctionsURL: state => state.FirebaseFunctionsURL
    })
  },
  mounted() {
    this.Form.email = this.$route.query.email;
    this.Form.PWC = this.$route.query.pwc;
    // // console.log(
    //   "QUERY=" + this.$route.query.email + " " + this.$route.query.pwc
    // );
  },
  methods: {
    resetPassword: function() {
      {
        this.$validator
          .validateAll()
          .then(result => {
            //console.log("Result = " + result);

            if (result) {
              // // console.log("Password = " + this.Form.password);
              // // console.log(
              //   "Confirm Password = " + this.Form.confirmPassword
              // );

              if (this.Form.password !== this.Form.confirmPassword) {
                Vue.notify({
                  group: "not-matching-passwords",
                  title: "Important message",
                  text: "The passwords are not similar"
                });
              } else {
                // // console.log(this.FirebaseFunctionsURL +
                //     "resetPassword?userEmail=" +
                //     this.Form.email +
                //     "&passwordResetCode=" +
                //     this.Form.PWC +
                //     "&newPassword=" +
                //     this.Form.confirmPassword);
                Axios.get(
                  this.FirebaseFunctionsURL +
                    "resetPassword?userEmail=" +
                    this.Form.email +
                    "&passwordResetCode=" +
                    this.Form.PWC +
                    "&newPassword=" +
                    this.Form.confirmPassword
                ).then(response => {
                  // console.log("The password has been changed");
                  this.Form.passwordChanged = true;
                  Vue.notify({
                    group: "password-changed",
                    title: "Success",
                    text: "The password has been changed",
                    type: "success"
                  });
                });
              }
            } else {
              // console.log("Result false");
            }
          })
          .catch(() => {
            if (this.Debug === true) {
              // console.log(this.errors.all());
            }
          });
      }
    },
    login: function() {
      this.$router.push("/authentication/login");
    }
  }
};
</script>
